import { cx } from "../../lib/cx.js";
/* empty css            */
import { jsx } from "react/jsx-runtime";
//#region src/components/Toolbar/Toolbar.tsx
/**
* A row of controls over a list: search, filters, a spacer, the result count and
* actions. It wraps when there isn't room, keeping every control (the primary action
* included). A labelled group; Tab moves through it in order.
*/
function Toolbar({ inset = false, align = "center", className, ...rest }) {
	return /* @__PURE__ */ jsx("div", {
		role: "group",
		...rest,
		className: cx("ds-toolbar", inset && "ds-toolbar--inset", align === "end" && "ds-toolbar--align-end", className)
	});
}
/** Wraps a control to give it the toolbar's width for its kind. */
function ToolbarItem({ size, className, ...rest }) {
	return /* @__PURE__ */ jsx("div", {
		...rest,
		className: cx("ds-toolbar__item", size && `ds-toolbar__item--${size}`, className)
	});
}
/** Takes the free space, pushing what follows (the count, actions) to the end. */
function ToolbarSpacer({ className, ...rest }) {
	return /* @__PURE__ */ jsx("div", {
		"aria-hidden": "true",
		...rest,
		className: cx("ds-toolbar__spacer", className)
	});
}
/** The result count ("24 uploads"), read out when it changes. */
function ToolbarCount({ className, ...rest }) {
	return /* @__PURE__ */ jsx("span", {
		"aria-live": "polite",
		"aria-atomic": "true",
		...rest,
		className: cx("ds-toolbar__count", className)
	});
}
//#endregion
export { Toolbar, ToolbarCount, ToolbarItem, ToolbarSpacer };

//# sourceMappingURL=Toolbar.js.map